import { useState } from "react";
import { BASE_API } from '../api/Globals';
import { helpHttp } from "../helpers/helpHttp";

export const useFormNewPassword = (initialForm, validateForm, token) => {
	const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loadup, setLoadup] = useState(false);
	const [response, setResponse] = useState(null);

	const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validateForm(form));
	};

	const handleLogin = (e) => {
		e.preventDefault();
		setErrors(validateForm(form));

		if (Object.keys(errors).length === 0) {

			const arrUser = {
				password: form.rcontraseña
			};

			setLoadup(true);
			
			helpHttp().put(`${BASE_API}auth/new_password`, {
					body: arrUser,
					headers: {
						"Content-Type": "application/json; charset=utf-8",
						"Accept": "application/json",
						'Access-Control-Allow-Origin': '*',
						'x-access-token': token
					},
				})
				.then((res) => {
					if(res.response === 'on') {
						window.location.replace('/');
					} else if(res.response === 'off') {
						
						setLoadup(false);
					
						setForm(initialForm);
						setResponse(res.message);
					}
				});
		}  else {
			return;
		}
	};

	return {
		form,
		errors,
		loadup,
		response,
		handleChange,
		handleBlur,
		handleLogin
	};
};